/**
 * @flow
 * @relayHash 2efd16088a534db0644f5e9eb18c3eda
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DeliverableFilesList_files$ref = any;
export type DeliverableFilesListRefetchQueryVariables = {|
  first?: ?number,
  after?: ?string,
  orderBy?: ?string,
  storageClass?: ?string,
  deliverableState?: ?string,
  releaseId?: ?string,
  deliverableTitle?: ?string,
  fileName?: ?string,
|};
export type DeliverableFilesListRefetchQueryResponse = {|
  +$fragmentRefs: DeliverableFilesList_files$ref
|};
export type DeliverableFilesListRefetchQuery = {|
  variables: DeliverableFilesListRefetchQueryVariables,
  response: DeliverableFilesListRefetchQueryResponse,
|};
*/


/*
query DeliverableFilesListRefetchQuery(
  $first: Int
  $after: String
  $orderBy: String
  $storageClass: String
  $deliverableState: String
  $releaseId: String
  $deliverableTitle: String
  $fileName: String
) {
  ...DeliverableFilesList_files
}

fragment DeliverableFilesList_files on Query {
  finalFilesByOrg(first: $first, after: $after, orderBy: $orderBy, storageClass: $storageClass, deliverableState: $deliverableState, releaseId: $releaseId, deliverableTitle: $deliverableTitle, fileName: $fileName) {
    edges {
      node {
        id
        fileName
        fileSize
        fileUrl
        storageClass
        deliverable {
          title
          state
          release {
            name
            id
          }
          id
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edgeCount
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderBy",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "storageClass",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "deliverableState",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "releaseId",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "deliverableTitle",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fileName",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeliverableFilesListRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "DeliverableFilesList_files",
        "args": null
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DeliverableFilesListRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "finalFilesByOrg",
        "storageKey": null,
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "deliverableState",
            "variableName": "deliverableState"
          },
          {
            "kind": "Variable",
            "name": "deliverableTitle",
            "variableName": "deliverableTitle"
          },
          {
            "kind": "Variable",
            "name": "fileName",
            "variableName": "fileName"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          },
          {
            "kind": "Variable",
            "name": "orderBy",
            "variableName": "orderBy"
          },
          {
            "kind": "Variable",
            "name": "releaseId",
            "variableName": "releaseId"
          },
          {
            "kind": "Variable",
            "name": "storageClass",
            "variableName": "storageClass"
          }
        ],
        "concreteType": "DeliverableFinalFileNodeConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "DeliverableFinalFileNodeEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "DeliverableFinalFileNode",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fileName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fileSize",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fileUrl",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "storageClass",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "deliverable",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DeliverableNode",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "title",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "state",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "release",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ReleaseNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name",
                            "args": null,
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ]
                      },
                      (v1/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "edgeCount",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "DeliverableFilesListRefetchQuery",
    "id": null,
    "text": "query DeliverableFilesListRefetchQuery(\n  $first: Int\n  $after: String\n  $orderBy: String\n  $storageClass: String\n  $deliverableState: String\n  $releaseId: String\n  $deliverableTitle: String\n  $fileName: String\n) {\n  ...DeliverableFilesList_files\n}\n\nfragment DeliverableFilesList_files on Query {\n  finalFilesByOrg(first: $first, after: $after, orderBy: $orderBy, storageClass: $storageClass, deliverableState: $deliverableState, releaseId: $releaseId, deliverableTitle: $deliverableTitle, fileName: $fileName) {\n    edges {\n      node {\n        id\n        fileName\n        fileSize\n        fileUrl\n        storageClass\n        deliverable {\n          title\n          state\n          release {\n            name\n            id\n          }\n          id\n        }\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalCount\n    edgeCount\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cde4cd24d2cc079f8a172ed838cad6e0';
module.exports = node;
